<script lang="ts">
  import { nrkCategoryActive, nrkChevronDown, nrkList } from "@nrk/core-icons";
  import { sortParams, updateSortParams } from "state/page";
  import { currentViewType, isViewType } from "./viewType";
  import { orgSortDesc, orgZoomIn } from "@nrk/origo";
  import { isEmbedded } from "../../config";
  import SearchIndicator from "./SearchIndicator.svelte";
  import { getCountFromQuery } from "../../state/queries";
  import { getMimirSearchQuery } from "../../state/queries/mimir";
  import SizeAdjuster from "./SizeAdjuster.svelte";

  const sortImageByKey = "bildebanken-sort-by";
  const sortImageOrderKey = "bildebanken-sort-order";

  function setSortBy(value: import("state/params").SortParams["sortBy"]) {
    return function (this: HTMLInputElement) {
      if (!this.checked) return;
      localStorage.setItem(sortImageByKey, value);
      updateSortParams({sortBy: value});
    };
  }

  function setSortOrder(value: import("state/params").SortParams["sortOrder"]) {
    return function (this: HTMLInputElement) {
      if (!this.checked) return;
      localStorage.setItem(sortImageOrderKey, value);
      updateSortParams({sortOrder: value});
    };
  }

  const sortableFields: { field: import("state/params").SortParams["sortBy"]; label: string }[] = [
    {
      field: "mediaCreatedOn",
      label: "Fotografert",
    },
    {
      field: "createdOn",
      label: "Lastet opp",
    },
    // We leave this out until it is explicitly asked for by users
    // {
    //   field: "modifiedOn",
    //   label: "Sist endret",
    // },
  ];

  const sortOrders: { order: import("state/params").SortParams["sortOrder"]; label: string }[] = [
    {
      order: "desc",
      label: "Nyeste først",
    },
    {
      order: "asc",
      label: "Eldste først",
    },
  ];

  function handleChange(event: Event) {
    const target = event.target as HTMLInputElement;

    if (isViewType(target.value)) {
      currentViewType.set(target.value);
      viewTypeDropdownEl.hidden = true;
    }
  }

  let viewTypeDropdownEl: HTMLElement;

  //count
  // const mimirQuery = getMimirSearchQuery();
  // $: busy = $mimirQuery.isLoading || $mimirQuery.isRefetching;
  // $: mimirCount = getCountFromQuery(mimirQuery);
  // $: noHits = !busy && $mimirCount === 0;

</script>

<div class="wrapper">
<!--    <div class="count">-->
<!--      {#if !noHits}-->
<!--        <SearchIndicator />-->
<!--      {/if}-->
<!--    </div>-->
    <SizeAdjuster css="desktop-only"/>
    <button class="org-button dropdown-button mobile-only" aria-label="størrelse på bildene">
      {@html orgZoomIn}
      <span class="dropdown-hint-icon">{@html nrkChevronDown}</span>
    </button>
    <bb-dropdown class="mobile-only" hidden>
      <SizeAdjuster css="mobile-only"/>
    </bb-dropdown>
  <button class="org-button dropdown-button sort-button" aria-label="Sorter">
    <span class="mobile-only">{@html orgSortDesc}</span>
    <span class="desktop-only">
      {sortableFields.find((field) => field.field === $sortParams.sortBy)?.label}
      : {sortOrders.find((field) => field.order === $sortParams.sortOrder)?.label ?? ""}
    </span>
    <span class="dropdown-hint-icon">{@html nrkChevronDown}</span>
  </button>
  <bb-dropdown class="sort" hidden>
    <fieldset class="org-fieldset">
      <legend>Sorter etter</legend>
      {#each sortableFields as field (field.field)}
        <label>
          <input
            class="org-input"
            type="radio"
            name="sort-by"
            value={field.field}
            checked={$sortParams.sortBy === field.field}
            on:change={setSortBy(field.field)}
          />
          {field.label}
        </label>
      {/each}
    </fieldset>
    <fieldset class="org-fieldset">
      <legend>Rekkefølge</legend>
      {#each sortOrders as order (order.order)}
        <label>
          <input
            class="org-input"
            type="radio"
            value={order.order}
            name="sort-order"
            checked={$sortParams.sortOrder === order.order}
            on:change={setSortOrder(order.order)}
          />
          {order.label}
        </label>
      {/each}
    </fieldset>
  </bb-dropdown>

  <button class="org-button dropdown-button">
    {@html $currentViewType === "TILES" || $currentViewType === "COMPACT_TILES"
      ? nrkCategoryActive
      : nrkList}
    <span class="dropdown-hint-icon">
      {@html nrkChevronDown}
    </span>
  </button>
  <bb-dropdown hidden bind:this={viewTypeDropdownEl}>
    <label class="org-button">
      <input
        type="radio"
        name="view-type"
        value="TILES"
        checked={$currentViewType === "TILES"}
        on:change={handleChange}
      />
      {@html nrkCategoryActive} Rutenett
    </label>
    <label class="org-button">
      <input
        type="radio"
        name="view-type"
        value="COMPACT_TILES"
        checked={$currentViewType === "COMPACT_TILES"}
        on:change={handleChange}
      />
      {@html nrkCategoryActive} Kompakt rutenett
    </label>
    <label class="org-button">
      <input
        type="radio"
        name="view-type"
        value="TABLE"
        checked={$currentViewType === "TABLE"}
        on:change={handleChange}
      />
      {@html nrkList} Liste
    </label>
  </bb-dropdown>
</div>

<style>
  .wrapper {
    display: flex;
    flex-direction: row;
  }

  bb-dropdown {
    background: var(--color-surface-secondary);
    color: var(--color-text-primary);
  }

  button {
    font-weight: normal;
  }

  /*To avoid this line from breaking at 375px*/
  .sort-button {
    padding-left:0;
    padding-right: var(--org-xsmall);
  }

  .dropdown-button {
    display: flex;
    align-items: flex-start;
    gap: 5px;
  }

  .dropdown-hint-icon {
    font-size: 0.5rem;
  }

  @media (max-width: 768px) {
    .desktop-only { display: none; }
  }

  @media (min-width: 769px) {
    .mobile-only { display: none; }
  }

  .sort label {
    display: block;
    margin: var(--org-small);
  }

  bb-dropdown.sort {
    padding: var(--org-small);
  }

  /*.count {*/
  /*  width: 80px;*/
  /*  flex-shrink: 0;*/
  /*  align-content: center;*/
  /*  margin-right: var(--org-small);*/
  /*}*/

</style>
